import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function Footer() {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;

  const footerLinks = [
    {
      title: t("siteName"),
      links: [
        { label: t("footer.links.spreadsheet"), href: `/${currentLang}#what-is` },
        { label: t("footer.links.products"), href: `/${currentLang}/products` },
        { label: t("footer.links.sellers"), href: `/${currentLang}/article/cssbuy-seller-guide` },
        { label: t("footer.links.guides"), href: `/${currentLang}#guides` },
      ],
    },
    {
      title: t("nav.reviews"),
      links: [
        { label: t("footer.links.reviews"), href: `/${currentLang}/article/cssbuy-review-2026` },
        { label: t("footer.links.qc"), href: `/${currentLang}/article/cssbuy-qc-guide` },
        { label: t("footer.links.comparisons"), href: `/${currentLang}/article/cssbuy-vs-superbuy` },
      ],
    },
    {
      title: t("nav.safety"),
      links: [
        { label: t("footer.links.safety"), href: `/${currentLang}#safety` },
        { label: t("footer.links.privacy"), href: `/${currentLang}` },
        { label: t("footer.links.terms"), href: `/${currentLang}` },
      ],
    },
  ];

  const languages = [
    { code: "en", label: "English" },
    { code: "pt", label: "Português" },
    { code: "de", label: "Deutsch" },
  ];

  return (
    <footer className="bg-gray-50 border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-emerald-700 flex items-center justify-center">
                <i className="ri-article-line text-white text-lg" />
              </div>
              <span className="font-bold text-lg text-gray-900">{t("siteName")}</span>
            </div>
            <p className="text-sm text-gray-600 leading-relaxed">{t("footer.languages")}</p>
            <div className="flex flex-wrap gap-2 mt-3">
              {languages.map((lang) => (
                <Link
                  key={lang.code}
                  to={`/${lang.code}`}
                  className={`px-2.5 py-1 rounded-md text-xs font-medium ${
                    currentLang === lang.code
                      ? "bg-emerald-700 text-white"
                      : "bg-white text-gray-600 border border-gray-200 hover:border-emerald-300"
                  }`}
                >
                  {lang.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Link columns */}
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-semibold text-sm text-gray-900 mb-3">{group.title}</h4>
              <ul className="space-y-2">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-gray-600 hover:text-emerald-700 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom */}
        <div className="mt-10 pt-6 border-t border-gray-200">
          <p className="text-xs text-gray-500 text-center leading-relaxed">
            {t("footer.disclaimer")}
          </p>
          <p className="text-xs text-gray-400 text-center mt-2">
            © 2026 cssbuybr.quest — All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}